import React from "react";
import { Link } from "react-router-dom";
import SubscribeNewsletter from "../SubscribeNewsletter/SubscribeNewsletter";

const Footer = () => {
  // Social media URLs - replace these with your actual URLs
  const socialMedia = {
    facebook: "https://www.facebook.com/profile.php?id=61558489517391",
    instagram: "https://www.instagram.com/onetimesuccess",
    youtube: "https://www.youtube.com/@onetimesuccess",
    tiktok: "https://www.tiktok.com/@onetimesuccess",
    whatsapp: "https://wa.me/2347013888777",
    playstore:
      "https://play.google.com/store/apps/details?id=com.onetimesuccess", // Replace with your actual Play Store URL
    appstore: "https://apps.apple.com/us/app/onetimesuccess/id123456789", // Replace with your actual App Store URL
  };

  return (
    <footer>
      <div className="container">
        <div className="top-footer">
          <div className="row">
            {/* <div className="col-sm-2">
                            <div className="footer-logo">
                                <Link to="/"><img
                                    src="../assets/frontend/img/foot-logo.png"
                                    alt="site-logo"
                                />
                                </Link>
                            </div>
                        </div> */}
            <div className="col-sm-7">
              <h3>Quick Links</h3>
              <div className="footer-nav">
                <ul className="clearfix">
                  <li>
                    <Link to="/news">Our News</Link>
                  </li>
                  {/*<li>
                                        <Link to="/pages/cancellation-policy">Cancellation policy</Link>
                                    </li>*/}
                  <li>
                    <Link to="/terms-and-conditions">Terms & Conditions</Link>
                  </li>
                  <li>
                    <Link to="/privacy-policy">Privacy Policy</Link>
                  </li>
                  <li>
                    <Link to="/pages/about-us">About Us</Link>
                  </li>
                  <li>
                    <Link to="/contact-us">Contact Us</Link>
                  </li>
                </ul>
              </div>
            </div>
            {/* <div className="col-sm-2">
              <h3>Explore</h3>
              <div className="footer-nav">
                <ul className="clearfix">
                  <li>
                  <Link to="/">Careers</Link>
                  </li>
                  <li>
                    <Link to="/">Locations</Link>
                  </li>
                  <li>
                    <Link to="/">Investors</Link>
                  </li>
                  <li>
                    <Link to="/">Press Room</Link>
                  </li>
                  <li>
                    <Link to="/contact-us">Contact Us</Link>
                  </li>
                </ul>
              </div>
            </div> */}
            <div className="col-sm-5">
              <div style={{ marginBottom: "25px" }}>
                <h3>Sign Up for Our Newsletter</h3>
                <SubscribeNewsletter></SubscribeNewsletter>
              </div>
              <div className="social-nav clearfix" style={{ paddingLeft: 0 }}>
                <h3 style={{ marginBottom: "15px" }}>Connect With Us</h3>
                <ul
                  className="clearfix"
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    gap: "5px",
                    margin: 0,
                    padding: 0,
                  }}
                >
                  <li style={{ padding: 0, margin: 0 }}>
                    <a
                      href={socialMedia.facebook}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ fontSize: "24px" }}
                    >
                      <i className="fa fa-facebook"></i>
                    </a>
                  </li>
                  <li style={{ padding: 0, margin: 0 }}>
                    <a
                      href={socialMedia.instagram}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ fontSize: "24px" }}
                    >
                      <i className="fa fa-instagram"></i>
                    </a>
                  </li>
                  <li style={{ padding: 0, margin: 0 }}>
                    <a
                      href={socialMedia.youtube}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ fontSize: "24px" }}
                    >
                      <i className="fa fa-youtube"></i>
                    </a>
                  </li>
                  <li style={{ padding: 0, margin: 0 }}>
                    <a
                      href={socialMedia.tiktok}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ fontSize: "24px", fontWeight: "bold" }}
                    >
                      TikTok
                    </a>
                  </li>
                  <li style={{ padding: 0, margin: 0 }}>
                    <a
                      href={socialMedia.whatsapp}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ fontSize: "24px" }}
                    >
                      <i className="fa fa-whatsapp"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Mobile App Download Section */}
        <div
          className="app-download-section"
          style={{
            marginTop: "30px",
            marginBottom: "30px",
            textAlign: "center",
          }}
        >
          <h3 style={{ marginBottom: "15px" }}>Download Our Mobile App</h3>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "20px",
              flexWrap: "wrap",
            }}
          >
            <a
              href={socialMedia.playstore}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
                alt="Get it on Google Play"
                style={{ height: "50px" }}
              />
            </a>
            {/* <a
              href={socialMedia.appstore}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="../assets/frontend/img/app-store-badge.png"
                alt="Download on the App Store"
                style={{ height: "50px" }}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src =
                    "https://developer.apple.com/app-store/marketing/guidelines/images/badge-download-on-the-app-store.svg";
                }}
              />
            </a> */}
          </div>
        </div>

        <div className="bot-footer">
          <p>
            © Copyright 2025 by <Link to="/">One Time Success</Link>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
